import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "overlay", "assetLayer", "editBtn"]
  static values = {
    stageId: Number,
    cols: { type: Number, default: 20 },
    rows: { type: Number, default: 20 },
    canEdit: { type: Boolean, default: false },
    selectedKey: { type: String, default: "" },
    editMode: { type: Boolean, default: false },
  }

  toggleEdit() {
    if (!this.canEditValue) return
    this.editModeValue = !this.editModeValue
  }

  editModeValueChanged() {
    if (!this.hasPickerTarget) return
    if (this.editModeValue) {
      this.pickerTarget.classList.remove("hidden")
      this.element.classList.add("stage-edit-mode")
      if (this.hasEditBtnTarget) this.editBtnTarget.classList.add("ring-2", "ring-tavern-gold")
      // Show delete buttons on placed assets
      if (this.hasAssetLayerTarget) {
        this.assetLayerTarget.querySelectorAll(".asset-delete-btn").forEach(btn => {
          btn.classList.remove("hidden")
          btn.classList.add("flex")
        })
      }
    } else {
      this.pickerTarget.classList.add("hidden")
      this.element.classList.remove("stage-edit-mode")
      if (this.hasEditBtnTarget) this.editBtnTarget.classList.remove("ring-2", "ring-tavern-gold")
      if (this.hasOverlayTarget) this.overlayTarget.classList.add("hidden")
      this.selectedKeyValue = ""
      if (this.hasAssetLayerTarget) {
        this.assetLayerTarget.querySelectorAll(".asset-delete-btn").forEach(btn => {
          btn.classList.add("hidden")
          btn.classList.remove("flex")
        })
      }
    }
  }

  selectAsset(event) {
    const btn = event.currentTarget
    const key = btn.dataset.assetKey
    if (this.selectedKeyValue === key) {
      this.selectedKeyValue = ""
    } else {
      this.selectedKeyValue = key
    }
  }

  selectedKeyValueChanged() {
    // Highlight selected picker button
    if (this.hasPickerTarget) {
      this.pickerTarget.querySelectorAll("[data-asset-key]").forEach(btn => {
        const active = btn.dataset.assetKey === this.selectedKeyValue
        btn.classList.toggle("ring-2", active)
        btn.classList.toggle("ring-tavern-gold", active)
      })
    }
    // Show/hide placement overlay
    if (this.hasOverlayTarget) {
      if (this.selectedKeyValue && this.editModeValue) {
        this.overlayTarget.classList.remove("hidden")
      } else {
        this.overlayTarget.classList.add("hidden")
      }
    }
  }

  async placeAsset(event) {
    if (!this.selectedKeyValue || !this.canEditValue) return
    const rect = this.overlayTarget.getBoundingClientRect()
    const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
    const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height))

    const res = await fetch(`/stages/${this.stageIdValue}/stage_assets`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
      },
      body: JSON.stringify({ stage_asset: { asset_key: this.selectedKeyValue, x, y } }),
    })
    if (!res.ok) { console.warn("stage-asset-composer: place failed", res.status) }
  }

  async removeAsset(event) {
    event.preventDefault()
    event.stopPropagation()
    const assetEl = event.currentTarget.closest("[data-asset-id]")
    if (!assetEl) return
    const id = Number(assetEl.dataset.assetId)

    const res = await fetch(`/stages/${this.stageIdValue}/stage_assets/${id}`, {
      method: "DELETE",
      credentials: "same-origin",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" },
    })
    if (!res.ok) { console.warn("stage-asset-composer: remove failed", res.status) }
  }
}
